(() => {
  // src/js/components/archivefilter.js
  var ArchiveFilter = class {
    constructor(elements) {
      this.elements = elements;
    }
    static create() {
      const filter = window.Store.app.theBody.querySelector(".js-archive-filter");
      if (!filter)
        return null;
      const select = filter.querySelector("select");
      const redirect_path = select.dataset.redirectPath ? select.dataset.redirectPath : "";
      const redirect_cat = select.dataset.redirectPath ? select.dataset.redirectCat : "";
      const obj_filter = {
        select,
        redirect_path,
        redirect_cat
      };
      const obj = new ArchiveFilter(obj_filter);
      obj.setSelectedOption(window.Store.data.archive_filter_select, window.Store.data.archive_filter_index);
      obj.setSelectedOptionFromSingle(window.Store.data.single_filter_value);
      obj.filterListener();
      return obj;
    }
    filterListener() {
      if (this.elements.select && this.elements.redirect_path && this.elements.redirect_cat) {
        this.elements.select.addEventListener("change", (e) => {
          let value;
          let url;
          let selected_index;
          const is_archive = e.target.selectedOptions[0].dataset.isArchive ? true : false;
          if (is_archive) {
            url = `${this.elements.redirect_path}`;
            selected_index = e.target.selectedIndex;
          }
          if (!is_archive) {
            value = e.target.selectedOptions[0].value;
            url = `${this.elements.redirect_path}${this.elements.redirect_cat}${value}`;
            selected_index = e.target.selectedIndex;
          }
          window.Store.data.archive_filter_select = e.target.id;
          window.Store.data.archive_filter_index = selected_index;
          window.Store.app.barba.go(url);
        });
      }
    }
    setSelectedOption(archive_filter_select, selected_index) {
      if (archive_filter_select && selected_index) {
        const select = document.getElementById(archive_filter_select);
        select.options[selected_index].selected = true;
        window.Store.data.archive_filter_select = null;
        window.Store.data.archive_filter_index = null;
      }
      return;
    }
    setSelectedOptionFromSingle(single_filter_value) {
      if (single_filter_value) {
        if (!this.elements.select.options.length)
          return;
        for (let index = 0; index < this.elements.select.options.length; index++) {
          const option = this.elements.select.options[index];
          if (single_filter_value === option.value) {
            this.elements.select.options[index].selected = true;
            window.Store.data.single_filter_value = null;
          }
        }
      }
      return;
    }
  };
  function render() {
    window.Store.components.archivefilter.obj = ArchiveFilter.create();
  }
  window.Store.components.archivefilter = {
    obj: null,
    render: null
  };
  window.Store.components.archivefilter.render = render;
})();
